// import Home from './views/Home.vue';
import TemplateIndex from "./views/templates/Index.vue";
import TemplateForm from "./views/templates/Form.vue";
import FileIndex from "./views/files/Index.vue";
import ProjectIndex from "./views/projects/Index.vue";
import ProjectForm from "./views/projects/Form.vue";
import CompanyIndex from "./views/companies/Index.vue";
import CompanyForm from "./views/companies/Form.vue";
import UserIndex from "./views/users/Index.vue";
import UserForm from "./views/users/Form.vue";
import UserRoles from "./views/users/Roles.vue";
import RoleIndex from "./views/roles/Index.vue";
import RoleForm from "./views/roles/Form.vue";
import ReportIndex from "./views/reports/Index.vue";
import SecurityQuarantineIndex from "./views/security/quarantine/Index.vue";

export const PrivateRoutes = [
  {
    path: "",
    component: ReportIndex,
    name: "index",
    meta: {
      title: "Home",
      menu: "index",
    },
  },
  {
    path: "/templates",
    component: TemplateIndex,
    name: "templates",
    props: true,
    meta: {
      title: "Plantillas",
      menu: "templates",
      buttonName: "Nueva Plantilla",
      buttonLink: { name: "new-template-form" },
    },
  },
  {
    path: "/templates/new",
    component: TemplateForm,
    name: "new-template-form",
    meta: {
      title: "Nueva Plantilla",
      menu: "templates",
    },
  },
  {
    path: "/templates/:dataId/edit",
    component: TemplateForm,
    name: "edit-template-form",
    props: true,
    meta: {
      title: "Editar Plantilla",
      menu: "templates",
    },
  },
  {
    path: "/files",
    component: FileIndex,
    name: "files",
    props: true,
    meta: {
      title: "Archivos",
      menu: "files",
    },
  },
  {
    path: "/companies",
    component: ProjectIndex,
    name: "companies",
    props: true,
    meta: {
      title: "Empresas",
      menu: "companies",
    },
  },
  {
    path: "/projects",
    component: ProjectIndex,
    name: "projects",
    props: true,
    meta: {
      title: "Proyectos",
      menu: "projects",
      buttonName: "Nuevo Proyecto",
      buttonLink: { name: "new-project-form" },
    },
  },
  {
    path: "/projects/new",
    component: ProjectForm,
    name: "new-project-form",
    meta: {
      title: "Nuevo Proyecto",
      menu: "projects",
    },
  },
  {
    path: "/projects/:dataId/edit",
    component: ProjectForm,
    name: "edit-project-form",
    props: true,
    meta: {
      title: "Editar Proyecto",
      menu: "projects",
    },
  },
  {
    path: "/companies",
    component: CompanyIndex,
    name: "companies",
    props: true,
    meta: {
      title: "Empresas",
      menu: "companies",
      buttonName: "Nueva Empresa",
      buttonLink: { name: "new-company-form" },
    },
  },
  {
    path: "/companies/new",
    component: CompanyForm,
    name: "new-company-form",
    meta: {
      title: "Nueva Empresa",
      menu: "companies",
    },
  },
  {
    path: "/companies/:dataId/edit",
    component: CompanyForm,
    name: "edit-company-form",
    props: true,
    meta: {
      title: "Editar Empresa",
      menu: "companies",
    },
  },
  {
    path: "/users",
    component: UserIndex,
    name: "users",
    props: true,
    meta: {
      title: "Usuarios",
      menu: "users",
      buttonName: "Nuevo Usuario",
      buttonLink: { name: "new-user-form" },
    },
  },
  {
    path: "/users/new",
    component: UserForm,
    name: "new-user-form",
    meta: {
      title: "Nuevo Usuario",
      menu: "users",
    },
  },
  {
    path: "/users/:dataId/edit",
    component: UserForm,
    name: "edit-user-form",
    props: true,
    meta: {
      title: "Editar Usuario",
      menu: "users",
    },
  },
  {
    path: "/users/:dataId/roles",
    component: UserRoles,
    name: "users-assign-roles",
    props: true,
    meta: {
      title: "Asignar roles",
      menu: "users",
    },
  },
  {
    path: "/roles",
    component: RoleIndex,
    name: "roles",
    props: true,
    meta: {
      title: "Roles",
      menu: "roles",
      buttonName: "Nuevo Rol",
      buttonLink: { name: "new-role-form" },
    },
  },
  {
    path: "/roles/new",
    component: RoleForm,
    name: "new-role-form",
    meta: {
      title: "Nuevo Rol",
      menu: "roles",
    },
  },
  {
    path: "/roles/:dataId/edit",
    component: RoleForm,
    name: "edit-role-form",
    props: true,
    meta: {
      title: "Editar Rol",
      menu: "roles",
    },
  },
  {
    path: "/reports",
    component: ReportIndex,
    name: "reports",
    props: true,
    meta: {
      title: "Reportes",
      menu: "reports",
    },
  },
  {
    path: "/security/quarantine",
    component: SecurityQuarantineIndex,
    name: "quarantine",
    props: true,
    meta: {
      title: "Seguridad",
      menu: "quarantine",
    },
  },
];
